<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <table class="optionalComponentSectionTable">
        <tr>
            <td *ngIf="powerCapacity.powerOutput">
                <span>
                    <b>Power Output:&nbsp;</b>
                    {{ powerCapacity.powerOutput }} MW
                </span>
            </td>

            <td *ngIf="powerCapacity.thermalOutput">
                <span>
                    <b>Thermal Output:&nbsp;</b>
                    {{ powerCapacity.thermalOutput }} MW
                </span>
            </td>

            <td *ngIf="powerCapacity.powerCapacity">
                <span>
                    <b>Power Capacity:&nbsp;</b>
                    {{ powerCapacity.powerCapacity }} MWh
                </span>
            </td>

            <td *ngIf="powerCapacity.batteryType">
                <span>
                    <b>Battery Type:&nbsp;</b>
                    {{ powerCapacity.batteryType }}
                </span>
            </td>
        </tr>
    </table>
</div>
</ng-template>

<ng-template #template_mobile let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <table class="optionalComponentSectionTable">
        <tr>
            <td *ngIf="powerCapacity.powerOutput">
                <span>
                    <b>Power Output:&nbsp;</b>
                    {{ powerCapacity.powerOutput }} MW
                </span>
            </td>
            <td *ngIf="powerCapacity.thermalOutput">
                <span>
                    <b>Thermal Output:&nbsp;</b>
                    {{ powerCapacity.thermalOutput }} MW
                </span>
            </td>
            <td *ngIf="powerCapacity.powerCapacity">
                <span>
                    <b>Power Capacity:&nbsp;</b>
                    {{ powerCapacity.powerCapacity }} MWh
                </span>
            </td>
            <td *ngIf="powerCapacity.batteryType">
                <span>
                    <b>Battery Type:&nbsp;</b>
                    {{ powerCapacity.batteryType }}
                </span>
            </td>
        </tr>
    </table>
</div>
</ng-template>